import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import {
  getTransactionBillingAddress,
  getTransactionBillingAddressScheduleTable,
} from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  salesOrderPaymentTable,
  salesOrderScheduleTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, Tabs, Tab } from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

export default function SalesOrderBilling({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);

  async function getTransactionBillingAddressData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionBillingAddressScheduleTable(
        user.token,
        {
          id: params.docNo,
          limit,
          offset,
        }
      );

      setRowData(data.data);
      setLoading(false);
      return { rows: data.data, total: data.data.length, error: false };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([])
  }

  return (
    <>
      <Box>
        {/* <Box className="viewDetilsBox">
            <Grid container className="mb-2" spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Grid container>
                  <Grid item xs={12} sm={6} md={4}>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} className="m-b-10">
                        <p className="titleHeading">Billing Information</p>
                        <p className="tFormlabel">TERMS</p>
                        <p className="tFormName">{el.terms}</p>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} className="m-b-10">
                        <p className="tFormlabel">BILLING SCHEDULE</p>
                        <p className="tFormName"></p>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6} md={8}>
                    <Grid container>
                      <Grid item xs={12} md={6} className="m-b-10">
                        <p className="titleHeading">Billing Address</p>
                        <p className="tFormlabel">BILL TO</p>
                        <p className="tFormName">{el.bill_to}</p>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">
                  INVOICE DELIVERY METHOD PER CLIENT RECORD
                </p>
                <p className="tFormName">
                  {el.invoice_delivery_method_per_client_record}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">UPLIFT TYPE (FROM CONTRACT)</p>
                <p className="tFormName">{el.uplift_type}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">TAX PREFIX</p>
                <p className="tFormName">{el.tax_prefix}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">CONTRACT NOTES PER CONTRACT RECORD</p>
                <p className="tFormName">
                  {el.contract_notes_per_contract_record}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">
                  UPLIFT FOR SYSTEM CALCS (FROM CONTRACT)
                </p>
                <p className="tFormName">{el.uplift_for_system_calcs}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">TAX SUFFIX</p>
                <p className="tFormName">{el.tax_suffix}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">
                  BILLING INSTRUCTION PER CLIENT RECORD
                </p>
                <p className="tFormName">
                  {" "}
                  {el.billing_instruction_per_client_record}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">
                  UPLIFT PER PAPER CONTRACT (FROM CONTRACT)-NEW
                </p>
                <p className="tFormName">{el.uplift_per_paper_contract}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">GST/VAT REG ID</p>
                <p className="tFormName">{el.gst_vat_reg_id}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel"></p>
                <p className="tFormName"></p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">UPLIFT PER PAPER CONTRACT-SO-NEW</p>
                <p className="tFormName">
                  {el.uplift_per_paper_contract_so_new}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">GST/VAT SHIP TO COUNTRY</p>
                <p className="tFormName">{el.gst_vat_ship_to_country}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel"></p>
                <p className="tFormName"></p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel">GST/VAT NUMBER</p>
                <p className="tFormName">{el.gst_vat_number}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <p className="tFormlabel"></p>
                <p className="tFormName"></p>
              </Grid>
            </Grid>
          </Box> */}
        <Box px={2}>
          <Box
            sx={{
              maxWidth: { xs: "100%", sm: "100%", md: "100%" },
              bgcolor: "#fff",
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={(e, nv) => {
                setTabIndex(nv);
              }}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              className="tabs-sub-bkg"
            >
              <Tab label="Payment Events" />
              <Tab label="Payment" />
              <Tab label="Schedule" />
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
              <AgGridPaginatedTable
                getTableRows={getTransactionNotAvailable}
                columns={salesOrderPaymentTable}
                refreshCounter={0}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <Box>
                <Grid container>
                  <Grid item xs={12} sm={6} py={1}>
                    <p className="tFormlabel">PAYMENT METHOD</p>
                    <p className="tFormName"></p>
                  </Grid>
                </Grid>
              </Box>
            </TabPanel>
            <TabPanel value={tabIndex} index={2}>
              <AgGridPaginatedTable
                getTableRows={getTransactionBillingAddressData}
                columns={salesOrderScheduleTable}
                refreshCounter={0}
              />
            </TabPanel>
          </Box>
        </Box>
      </Box>
    </>
  );
}
